<template>
  <ElDialog
      v-model="isShow"
      :title="dialogFlag==='create'?$t('add.new.history'):dialogFlag==='edit'?$t('edit.history'):$t('follow.detail')"
      :footer="null"
      centered
      :width="800"
      :top="'8vh'"
      destroyOnClose
      @cancel="close"
      :class="[isHeadLine ? 'headline' : 'noheadline']"
  >
    <div class="inners_warning" v-loading="isDetailLoading">
      <el-form
          ref="ruleFormRef"
          :model="ruleForm"
          :rules="rules"
          style="width: 100%;padding: 0px 15px"
          class="demo-ruleForm"
          label-width="auto"
      >
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('common.customer.number')+':'" prop="customerCode">
              <el-input
                  size="small"
                  :disabled="!formIsEditable || dialogFlag === 'create' || dialogFlag === 'edit'"
                  v-model="ruleForm.customerCode"
                  :placeholder="$t('common.please.input')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('common_customer_name')+':'" prop="customerName">
              <el-input
                  size="small"
                  :disabled="!formIsEditable || dialogFlag === 'create' || dialogFlag === 'edit'"
                  v-model="ruleForm.customerName"
                  :placeholder="$t('common.please.input')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('common.contact')+':'" prop="mailCustomerFollowContactDTOList">
              <el-select
                  size="small"
                  v-model="ruleForm.mailCustomerFollowContactDTOList"
                  multiple
                  collapse-tags
                  collapse-tags-tooltip
                  :placeholder="$t('common.email.chooseContact')"
                  style="width: 240px"
              >
                <el-option
                    v-for="item in targetNewObj"
                    :key="item.contactId"
                    :label="item.contactName"
                    :value="item.contactId"
                    :disabled="!formIsEditable"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('follow.date')+':'" prop="followTime">
              <el-date-picker
                  size="small"
                  :disabled="!formIsEditable"
                  v-model="ruleForm.followTime"
                  type="datetime"
                  :placeholder="$t('sys.tip.select.date')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('follow.ways')+':'" prop="followWay">
              <el-input
                  size="small"
                  :disabled="!formIsEditable"
                  v-model="ruleForm.followWay"
                  :placeholder="$t('common.please.input')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('follow.target')+':'" prop="followAim">
              <el-input size="small" v-model="ruleForm.followAim" :disabled="!formIsEditable"
                        :placeholder="$t('common.please.input')"/>
            </el-form-item>
          </el-col>
        </el-row>
        <!--        新增字段-->
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('common.follow.next')+':'" prop="followPlanTime">
              <el-date-picker
                  size="small"
                  :disabled="!formIsEditable"
                  v-model="ruleForm.followPlanTime"
                  type="datetime"
                  :placeholder="$t('sys.tip.select.date')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('common.follow.plan')+':'" prop="followPlanDetail">
              <el-input size="small" v-model="ruleForm.followPlanDetail" :disabled="!formIsEditable"
                        :placeholder="$t('common.please.input')"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item :label="$t('follow.detail')+':'" prop="followDetail">
              <el-input
                  size="small"
                  :disabled="!formIsEditable"
                  v-model="ruleForm.followDetail"
                  style="width: 240px"
                  :rows="5"
                  type="textarea"
                  :placeholder="$t('common.please.input')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item :label="$t('common.remark')+':'" prop="remark">
              <el-input
                  size="small"
                  :disabled="!formIsEditable"
                  v-model="ruleForm.remark"
                  style="width: 240px"
                  :rows="5"
                  type="textarea"
                  :placeholder="$t('common.please.input')"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <template #footer v-if="formIsEditable">
      <div class="setting_center">
        <el-button size="small" @click="close" style="margin-right: 20px">{{ $t('common.sss16') }}</el-button>
        <el-button size="small" type="primary" @click="handleClick" :loading="isloading">{{
            $t('common.confirm')
          }}
        </el-button>
      </div>
    </template>
  </ElDialog>
</template>

<script setup>
import {ElButton, ElDialog, ElInput, ElMessage} from "element-plus";
import {ref, defineProps, watch, defineEmits, reactive, onMounted, computed} from 'vue'
import {useStore} from "vuex";
import Forms from "@/views/Customer/CreateCheck/Forms.vue";
import {emailReg, emptyUrl} from "@/utils/statusParams";
import {Plus} from "@element-plus/icons-vue";
import ConfirmDeletePopover from "@/components/ConfirmDeletePopover.vue";
import Cards from "@/views/Customer/Cards.vue";
import MyTitles from "@/views/Customer/Detail/MyTitles.vue";
import MoreCheck from "@/views/Customer/CreateCheck/MoreCheck.vue";
import {
  addCustomerFollowLog,
  getMailCustomerContactByCustomerId,
  queryByIdFollowLog,
  updateCustomerFollowLog
} from "@/api/customer";
import {useRoute} from "vue-router";
import dayjs from "dayjs";
import {i18n} from "@/lang";

const store = useStore();
const route = useRoute();
const emit = defineEmits()
const isShow = ref(false);
const fileDirName = ref("")
const loading = ref(false)
const ruleFormAllData = computed(() => store.state.customer.ruleForm)

const {value, isHeadLine, dialogFlag, currentItemDetail} = defineProps({
  value: {type: Boolean, default: false},
  isHeadLine: {type: Boolean, default: false},
  dialogFlag: {type: String, default: ''},
  currentItemDetail: {type: Object, default: {}}
})


const ruleForm = ref({
  customerCode: '',
  customerName: '',
  mailCustomerFollowContactDTOList: [],
  followTime: '',
  followWay: '',
  followAim: '',
  followDetail: '',
  remark: '',
  followPlanTime: "",
  followPlanDetail: ""
})

const ruleFormEmpty = ref({
  customerCode: '',
  customerName: '',
  mailCustomerFollowContactDTOList: [],
  followTime: '',
  followWay: '',
  followAim: '',
  followDetail: '',
  remark: '',
  followPlanTime: "",
  followPlanDetail: ""
})

const rules = reactive({
  customerCode: [{required: true, message: i18n.global.t("create.follow.detail.rules1"), trigger: ['change', 'blur']}],
  customerName: [{required: true, message: i18n.global.t('create.follow.detail.rules2'), trigger: ['change', 'blur']}],
  followTime: [{required: true, message: i18n.global.t('create.follow.detail.rules3'), trigger: ['change', 'blur']}],
  followAim: [{required: true, message: i18n.global.t('create.follow.detail.rules4'), trigger: ['change', 'blur']}],
})

// 表单是否可编辑
const formIsEditable = computed(() => {
  return dialogFlag === 'detail' ? false : true
})


onMounted(async () => {
  if (dialogFlag !== 'create') {
    await queryByIdFollowLogDetail()
  } else {
    Object.assign(ruleForm.value, ruleFormAllData.value)
  }
  await getAllContact()
})


// 获取客户详情
const isDetailLoading = ref(false)
const queryByIdFollowLogDetail = async () => {
  const payload = {
    id: currentItemDetail?.id
  }
  try {
    isDetailLoading.value = true
    console.log(payload, 'payload')
    let res = await queryByIdFollowLog(payload)
    console.log(res, 'res')
    Object.assign(ruleForm.value, {
      ...res.result,
      customerCode: ruleFormAllData.value.customerCode,
      customerName: ruleFormAllData.value.customerName,
      mailCustomerFollowContactDTOList: res.result.mailCustomerFollowContactDTOList.map(item => item.contactId)
    })
    isDetailLoading.value = false;
    console.log(ruleForm.value, 'ruleForm.value')
  } catch (e) {
    isDetailLoading.value = false;
  }
}


// 获取全部联系人
const targetNewObj = ref([])
const getAllContact = async () => {
  let res = await getMailCustomerContactByCustomerId({customerId: route.params.userId})
  if (res.code !== 200) {
    ElMessage.error(res.message)
    return
  }
  targetNewObj.value = res.result.map(item => ({contactId: item.id, contactName: item.name}))
}

const ruleFormRef = ref(null)
const teamId = computed(() => store.state.email.teamID)
const isloading = ref(false)
const handleClick = () => {
  ruleFormRef.value.validate(async (valid, fields) => {
    if (valid) {
      const {
        mailCustomerFollowContactDTOList,
        followAim,
        followDetail,
        followTime,
        followWay,
        remark,
        followPlanTime,
        followPlanDetail
      } = ruleForm.value
      let payload = {
        contactIdList: mailCustomerFollowContactDTOList,
        customerId: route.params.userId,
        followAim,
        followDetail,
        followTime: dayjs(followTime).format("YYYY-MM-DD HH:mm:ss"),
        followWay,
        remark,
        teamId: teamId.value,
        followPlanTime: followPlanTime ? dayjs(followPlanTime).format("YYYY-MM-DD HH:mm:ss") : '',
        followPlanDetail,
      }
      console.log(ruleForm.value, payload, 'payload')

      try {
        isloading.value = true
        // 判断是 更新 还是 添加
        const apiRequest = dialogFlag === 'create' ? addCustomerFollowLog : updateCustomerFollowLog
        if (dialogFlag === 'edit') {
          payload = {...payload, id: ruleForm.value?.id}
        }
        let res = await apiRequest(payload)
        ElMessage.success(res.result)
        isloading.value = false
        ruleForm.value = [];
        close()
        //   重新获取列表
        emit('getList')
      } catch (e) {
        isloading.value = false
      }
    }
  })

}


watch(() => value, (val) => {
  isShow.value = val;
}, {immediate: true})
const close = () => {
  emit("close");
}

const createDir = () => {
  emit("addDir", fileDirName.value)
}
</script>
<style scoped lang="less">
.fx-j-c {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.title_cdir {
  color: rgba(0, 0, 0, .85);
  font-weight: 700;
  font-size: 14px;
}

.fx-j-r {
  display: flex;
  justify-content: right;
  margin-top: 40px;
}

:deep(.el-form-item) {
  padding: 0px !important;
  margin-bottom: 18px !important;
}

.inners_warning {
  min-height: 400px !important;
}

</style>
